const initAnchorLinksInNav = () => {
  console.log('aa');
  if(document.querySelector('#nav-primary a[href^="#"]')){
    const links = document.querySelectorAll('#nav-primary a[href^="#"]');

    for (const link of links) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        console.log('klick');

        const targetId = link.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop -100,
            behavior: 'smooth'
          });
        }
      });
    }
  }
};
export default initAnchorLinksInNav;





